module.exports = __webpack_public_path__ + "static/img/3s-platform-bg.6f75259.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3s-platform-bg.png
// module id = fAp4
// module chunks = 0